/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNeighborhoodsTabContentRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetNeighborhoodsTabContentResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getNeighborhoodsTabContent = (request: GetNeighborhoodsTabContentRequest, options?: CashRequestOptions) => post<GetNeighborhoodsTabContentRequest, GetNeighborhoodsTabContentResponse>("/2.0/cash/get-neighborhoods-tab-content", request, {...options, rejectOnError: true })